import React, { FC, useEffect, useState } from 'react';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import styles from './CheckBox.module.scss';

type CheckBoxProps = {
  className?: string;
  label?: string;
  onChange?: (isChecked: boolean) => void;
  checked?: boolean;
  style?: React.CSSProperties;
};

const CheckBox: FC<CheckBoxProps> = ({
  className,
  onChange,
  label,
  checked = false,
  style,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (e: CheckboxChangeEvent) => {
    const newChecked = e.checked || false;
    setIsChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }
  };

  useEffect(() => {
    setIsChecked(!!checked);
  }, [checked]);

  return (
    <div className={styles.container} style={style}>
      <Checkbox
        className={className}
        inputId="includeLoadUnload"
        onChange={handleChange}
        checked={isChecked}
      />
      <label htmlFor="includeLoadUnload" className="p-checkbox-label text-sm">
        {label}
      </label>
    </div>
  );
};

export default CheckBox;
